import AddItemTableRow from "../AddItemTableRow.jsx";

const TableAddRow = ({ toolTipContent, onClick, className = '' }) => {
  const classes = ['common-table__add-row', className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <AddItemTableRow toolTipContent={toolTipContent} onClick={onClick} />
    </div>
  );
};

export default TableAddRow;
